import { createAction, createAsyncAction } from "typesafe-actions";
import { PenaltyGetActionTypes, PenaltyPayActionTypes } from "./types";
import GetPenaltyRequest from "../../models/penalty/GetPenaltyRequest";
import Penalty from "../../models/penalty/Penalty";
import PayPenaltyRequest from "../../models/penalty/PayPenaltyRequest";

export const getPenaltyActions = createAsyncAction(
    PenaltyGetActionTypes.REQUEST,
    PenaltyGetActionTypes.SUCCESS,
    PenaltyGetActionTypes.ERROR
)<GetPenaltyRequest, Penalty, any>();

export const clearPenaltyAction = createAction(PenaltyGetActionTypes.CLEAR)<void>();

export const payPenaltyActions = createAsyncAction(
    PenaltyPayActionTypes.REQUEST,
    PenaltyPayActionTypes.SUCCESS,
    PenaltyPayActionTypes.ERROR
)<PayPenaltyRequest, any, any>();
